export const PLAYBOOK_EXECUTION_TRIGGER_TYPES = {
    INCIDENT: 'Incident',
    TRIAGE: 'Triage',
    MONITOR_ALERT: 'Monitor-alert',
    INSIGHT: 'Insight',
    ENTITY: 'Entity'
};

export default PLAYBOOK_EXECUTION_TRIGGER_TYPES;
